const state = {
  initError: null,
  searchResultError: null,
  reservationError: null,
  reservationWarning: {
    type: null,
    messages: null
  },
  globalError: null
}

const getters = {
  getInitError: (state) => state.initError,
  getSearchResultError: (state) => state.searchResultError,
  getReservationError: (state) => state.reservationError,
  getReservationWarning: (state) => state.reservationWarning,
  getGlobalError: (state) => state.globalError
}

const mutations = {
  setInitError: (state, payload) => {
    state.initError = payload
  },
  setSearchResultError: (state, payload) => {
    state.searchResultError = payload
  },
  setReservationError: (state, payload) => {
    state.reservationError = payload
  },
  setReservationWarning: (state, payload) => {
    state.reservationWarning = payload
  },
  clearReservationError: (state) => {
    state.reservationError = null
  },
  setGlobalError: (state, payload) => {
    state.globalError = payload
  }
}

const actions = {
  setInitError: ({ commit }, payload) => {
    commit('setInitError', payload)
  },
  setSearchResultError: ({ commit }, payload) => {
    commit('setSearchResultError', payload)
  },
  setReservationError: ({ commit }, payload) => {
    commit('setReservationError', payload)
  },
  setReservationWarning: ({ commit }, payload) => {
    commit('setReservationWarning', payload)
  },
  clearReservationError: ({ commit }) => {
    commit('clearReservationError')
  },
  setGlobalError: ({ commit }, payload) => {
    commit('setGlobalError', payload)
  },
  clearGlobalError: ({ commit }) => {
    commit('setGlobalError', null)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
